import { render } from "./departments-model.vue?vue&type=template&id=fe6c1c02"
import script from "./departments-model.vue?vue&type=script&lang=js"
export * from "./departments-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__